const SectionHeader2 = ({
  title,
  classes,
}: {
  title: string;
  classes?: string;
}) => {
  return (
    <h3
      className={
        `font-[500] font-solina tracking-[5%] leading-[49px] transition-bg-1s h-fit text-[28px]` +
        classes
      }
    >
      {title}
    </h3>
  );
};

export default SectionHeader2;
